
import React from 'react';
import { SkipBackIcon, SkipForwardIcon } from '../icons/NavigationIcons';
import TimerControlButton from './TimerControlButton';

interface SkipButtonProps {
  direction: 'previous' | 'next';
  onClick: () => void;
  isMobile: boolean;
}

const SkipButton: React.FC<SkipButtonProps> = ({
  direction,
  onClick,
  isMobile
}) => {
  // Simplify the event handling to ensure consistent behavior
  const handleClick = (e: React.MouseEvent) => {
    console.log(`SkipButton ${direction} clicked`);
    onClick();
  };

  return (
    <TimerControlButton 
      onClick={handleClick}
      ariaLabel={direction === 'previous' ? "Previous" : "Next"}
    >
      {direction === 'previous' ? 
        <SkipBackIcon size={isMobile ? 20 : 24} /> : 
        <SkipForwardIcon size={isMobile ? 20 : 24} />
      }
    </TimerControlButton>
  );
};

export default SkipButton;
